import { useAuth } from "../../contexts/AuthContext";
import "./Feedback.css";
import { useMemo, useState } from "react";
import { useDebounce } from "../../customHooks/useDebounce";
import ErrorState from "../../components/ErrorState/ErrorState";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";
import FeedbackForm from "../../components/FeedbackForm/FeedbackForm";
import FeedbackPostList from "../../components/FeedbackPostList/FeedbackPostList";
import { useFeedback } from "../../customHooks/useFeedback";

function Feedback() {
  const { isFeedbackManager, user } = useAuth();
  const [showCompleted, setShowCompleted] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const debouncedSearch = useDebounce(searchInput, 300);

  const { feedbackPosts, loading, fetchError, refreshPosts, submitPost, likePost, completePost } =
    useFeedback(showCompleted);

  const filteredPosts = useMemo(
    () =>
      feedbackPosts.filter((p) => {
        const search = debouncedSearch.trim().toLowerCase();
        if (!search) return true;
        return (
          p.title.toLowerCase().includes(search) ||
          p.description.toLowerCase().includes(search) ||
          p.createdBy.toLowerCase().includes(search)
        );
      }),
    [debouncedSearch, feedbackPosts],
  );

  if (fetchError && !loading) {
    return (
      <div className="feedback-page">
        <ErrorState type="fetch" onAction={refreshPosts} fullPage />
      </div>
    );
  }

  return (
    <>
      <title>Projektkontrolle - Feedback</title>
      <div className="feedback-page">
        <HeaderComponent
          backDestination="/"
          pageTitle="Feedback"
          hasSearchBar
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          entityToSearch="Posts"
        />
        <div className="content-base feedback-content">
          <FeedbackForm createdById={user?.id ?? 0} onSubmit={submitPost} />
          <div className="feedback-posts-container">
            <LoadingSpinner loading={loading} isFullscreen={false} />
            {!loading && (
              <FeedbackPostList
                posts={filteredPosts}
                variant={isFeedbackManager ? "manager" : "default"}
                onLike={likePost}
                onComplete={completePost}
                showCompleted={showCompleted}
                setShowCompleted={setShowCompleted}
                refreshPosts={refreshPosts}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Feedback;
